/*
  Find a Retailer: "Use my location" on the locator (sections/far-locator.liquid).

  The browser's position becomes the nearest US ZIP or Canadian FSA centroid
  from the postal shards (the same files far-location.js reads). The code
  goes into the locator's postal field and the form is submitted as a
  visitor would, so far-locator.js runs its usual search, country filter and
  paging. far-locator.js is not changed.

  The coordinates are used once and never stored: no localStorage, no
  cookies. What the locator saves afterwards is the postal code's centroid,
  exactly as when a code is typed.

  Shards load only on click, and only the ones that can hold the nearest
  centroid. CELLS lists, for every shard, the 1° latitude by 2° longitude
  cells its centroids fall in (taken from the shard files; dev/far checks
  the table against them). Every centroid within MAX_KM is in the visitor's
  cell or the cells around it, so only shards listed there are candidates,
  each with a lower bound (the distance to its nearest such cell). The
  shards in the visitor's own cell load first, together; then only shards
  whose bound beats the best centroid found. The answer is exact, usually
  from one or two shards; a point with no shard around it (at sea, or far
  outside the US and Canada) loads nothing.

  The button is rendered hidden and shown here only when the browser has
  geolocation and the page is a secure context.

  window.PwFar.nearestPostal(config, lat, lng)  Promise of { postal, country, km } or null
  window.PwFar.nearestPostal.candidates(lat, lng)  [{ key, km }] the shards it may load, nearest first

  Needs far-algolia.js (PwFar.config) and far-ui.js (PwFar.ui.i18n), loaded
  before this file.
*/
(function () {
  'use strict';

  var PwFar = (window.PwFar = window.PwFar || {});
  if (PwFar.nearestPostal) return;

  var LAT_STEP = 1;
  var LNG_STEP = 2;
  var LNG_CELLS = 360 / LNG_STEP;
  // Farther than this from every centroid is not a US or Canadian location.
  var MAX_KM = 100;
  var KM_PER_DEGREE = 111.2;
  var TIMEOUT_MS = 10000;

  // Cells per shard, as "latCell,lngCell" (floor(lat / 1), floor(lng / 2)).
  var CELLS = {
    'ca': '41,-42 42,-42 42,-41 42,-40 43,-42 43,-41 43,-40 43,-34 43,-33 44,-41 44,-40 44,-39 44,-38 44,-34 44,-33 44,-32 45,-42 45,-41 45,-40 45,-39 45,-38 45,-37 45,-36 45,-34 45,-33 45,-32 45,-31 45,-30 46,-43 46,-42 46,-41 46,-40 46,-39 46,-38 46,-37 46,-36 46,-34 46,-33 46,-32 46,-31 46,-30 47,-43 47,-42 47,-41 47,-40 47,-39 47,-37 47,-36 47,-35 47,-34 47,-33 47,-31 47,-30 47,-28 47,-27 48,-63 48,-62 48,-47 48,-45 48,-41 48,-40 48,-37 48,-36 48,-35 48,-34 48,-33 48,-30 48,-29 48,-28 48,-27 49,-63 49,-62 49,-61 49,-60 49,-59 49,-58 49,-57 49,-56 49,-55 49,-54 49,-52 49,-51 49,-50 49,-49 49,-48 49,-47 49,-45 49,-42 49,-38 49,-37 49,-35 49,-34 49,-33 49,-30 49,-29 49,-28 50,-63 50,-62 50,-61 50,-60 50,-59 50,-58 50,-57 50,-56 50,-54 50,-53 50,-51 50,-50 50,-49 50,-48 50,-46 50,-42 50,-36 50,-35 50,-34 50,-32 51,-62 51,-61 51,-60 51,-59 51,-58 51,-57 51,-56 51,-55 51,-54 51,-52 51,-51 51,-49 51,-34 51,-29 52,-64 52,-63 52,-58 52,-57 52,-56 52,-55 52,-54 52,-52 52,-50 52,-34 53,-66 53,-65 53,-62 53,-59 53,-58 53,-57 53,-56 53,-55 53,-53 53,-51 53,-45 53,-40 53,-33 54,-66 54,-65 54,-61 54,-59 54,-58 54,-57 54,-56 54,-51 55,-64 55,-60 55,-58 55,-55 55,-49 55,-37 55,-31 56,-61 56,-59 56,-56 56,-53 56,-49 57,-59 57,-56 58,-64 59,-67 60,-68 60,-62 61,-66 63,-57 63,-47 64,-69 69,-53 71,-40 72,-62',
    'us-0': '17,-34 17,-33 18,-34 18,-33 38,-38 39,-38 40,-38 40,-37 41,-38 41,-37 41,-36 41,-35 42,-37 42,-36 43,-37 43,-36 43,-35 44,-37 44,-36 44,-35 44,-34 45,-36 45,-35 45,-34 46,-35 46,-34 47,-35',
    'us-1': '38,-38 39,-41 39,-40 39,-39 39,-38 40,-41 40,-40 40,-39 40,-38 40,-37 41,-41 41,-40 41,-39 41,-38 41,-37 41,-36 42,-41 42,-40 42,-39 42,-38 42,-37 43,-40 43,-39 43,-38 43,-37 44,-39 44,-38 44,-37',
    'us-2': '32,-41 32,-40 33,-42 33,-41 33,-40 33,-39 34,-42 34,-41 34,-40 34,-39 35,-43 35,-42 35,-41 35,-40 35,-39 35,-38 36,-42 36,-41 36,-40 36,-39 36,-38 37,-42 37,-41 37,-40 37,-39 37,-38 38,-42 38,-41 38,-40 38,-39 38,-38 39,-42 39,-41 39,-40 39,-39 39,-38 40,-41',
    'us-3': '24,-41 25,-41 26,-42 26,-41 27,-42 27,-41 28,-42 28,-41 29,-43 29,-42 29,-41 30,-45 30,-44 30,-43 30,-42 30,-41 31,-46 31,-45 31,-44 31,-43 31,-42 31,-41 32,-46 32,-45 32,-44 32,-43 32,-42 32,-41 33,-46 33,-45 33,-44 33,-43 33,-42 33,-41 34,-46 34,-45 34,-44 34,-43 34,-42 35,-46 35,-45 35,-44 35,-43 35,-42 36,-45 36,-44 36,-43 36,-42 36,-41',
    'us-4': '36,-45 36,-44 36,-43 36,-42 37,-45 37,-44 37,-43 37,-42 38,-44 38,-43 38,-42 38,-41 39,-44 39,-43 39,-42 39,-41 40,-44 40,-43 40,-42 40,-41 41,-44 41,-43 41,-42 41,-41 42,-44 42,-43 42,-42 43,-44 43,-43 43,-42 44,-44 44,-43 44,-42 45,-45 45,-44 45,-43 45,-42 46,-46 46,-45 46,-44 46,-43 46,-42 47,-45 47,-44',
    'us-5': '40,-48 40,-47 40,-46 41,-49 41,-48 41,-47 41,-46 42,-50 42,-49 42,-48 42,-47 42,-46 42,-45 42,-44 43,-52 43,-51 43,-50 43,-49 43,-48 43,-47 43,-46 43,-45 43,-44 44,-57 44,-56 44,-52 44,-51 44,-50 44,-49 44,-48 44,-47 44,-46 44,-45 44,-44 45,-58 45,-57 45,-56 45,-55 45,-54 45,-53 45,-52 45,-51 45,-50 45,-49 45,-48 45,-47 45,-46 45,-45 45,-44 46,-58 46,-57 46,-56 46,-55 46,-54 46,-53 46,-52 46,-51 46,-50 46,-49 46,-48 46,-47 46,-46 46,-45 47,-58 47,-57 47,-56 47,-55 47,-54 47,-53 47,-52 47,-51 47,-50 47,-49 47,-48 47,-47 47,-46 47,-45 48,-58 48,-57 48,-56 48,-55 48,-54 48,-53 48,-52 48,-51 48,-50 48,-49 48,-48 48,-47',
    'us-6': '36,-48 36,-47 36,-46 36,-45 37,-51 37,-50 37,-49 37,-48 37,-47 37,-46 37,-45 38,-52 38,-51 38,-50 38,-49 38,-48 38,-47 38,-46 38,-45 38,-44 39,-52 39,-51 39,-50 39,-49 39,-48 39,-47 39,-46 39,-45 39,-44 40,-51 40,-50 40,-49 40,-48 40,-47 40,-46 40,-45 40,-44 41,-52 41,-51 41,-50 41,-49 41,-48 41,-46 41,-45 41,-44 42,-52 42,-51 42,-50 42,-49 42,-46 42,-45 42,-44',
    'us-7': '25,-49 26,-50 26,-49 27,-50 27,-49 28,-51 28,-50 28,-49 28,-48 29,-53 29,-52 29,-51 29,-50 29,-49 29,-48 29,-47 29,-46 29,-45 30,-53 30,-52 30,-51 30,-50 30,-49 30,-48 30,-47 30,-46 30,-45 31,-54 31,-53 31,-52 31,-51 31,-50 31,-49 31,-48 31,-47 31,-46 32,-53 32,-52 32,-51 32,-50 32,-49 32,-48 32,-47 32,-46 33,-52 33,-51 33,-50 33,-49 33,-48 33,-47 33,-46 34,-52 34,-51 34,-50 34,-49 34,-48 34,-47 34,-46 35,-52 35,-51 35,-50 35,-49 35,-48 35,-47 35,-46 35,-45 36,-52 36,-51 36,-50 36,-49 36,-48 36,-47 36,-46',
    'us-8': '31,-57 31,-56 31,-55 31,-54 32,-58 32,-57 32,-56 32,-55 32,-54 32,-53 32,-52 33,-58 33,-57 33,-56 33,-55 33,-54 33,-53 33,-52 34,-58 34,-57 34,-56 34,-55 34,-54 34,-53 34,-52 35,-58 35,-57 35,-56 35,-55 35,-54 35,-53 35,-52 36,-59 36,-58 36,-57 36,-56 36,-55 36,-54 36,-53 36,-52 37,-60 37,-59 37,-58 37,-57 37,-56 37,-55 37,-54 37,-53 37,-52 38,-60 38,-59 38,-58 38,-57 38,-56 38,-55 38,-54 38,-53 38,-52 39,-61 39,-60 39,-59 39,-58 39,-57 39,-56 39,-55 39,-54 39,-53 39,-52 40,-60 40,-59 40,-58 40,-57 40,-56 40,-55 40,-54 40,-53 40,-52 41,-60 41,-59 41,-58 41,-57 41,-56 41,-55 41,-54 41,-53 42,-59 42,-58 42,-57 42,-56 42,-55 42,-54 42,-53 43,-59 43,-58 43,-57 43,-56 43,-55 43,-54 43,-53 44,-59 44,-58 44,-57 44,-56 44,-55 44,-54 44,-53 45,-59 45,-58 45,-57 46,-59 46,-58 47,-59 47,-58 48,-59',
    'us-9': '-15,-86 13,72 14,72 15,72 19,-78 20,-79 20,-78 21,-80 21,-79 22,-80 32,-59 32,-58 33,-60 33,-59 33,-58 34,-61 34,-60 34,-59 34,-58 35,-61 35,-60 35,-59 35,-58 36,-62 36,-61 36,-60 36,-59 37,-62 37,-61 37,-60 38,-62 38,-61 38,-60 39,-62 39,-61 40,-63 40,-62 40,-61 41,-63 41,-62 41,-61 42,-63 42,-62 42,-61 42,-60 42,-59 43,-63 43,-62 43,-61 43,-60 43,-59 44,-63 44,-62 44,-61 44,-60 44,-59 45,-62 45,-61 45,-60 45,-59 46,-63 46,-62 46,-61 46,-60 46,-59 47,-63 47,-62 47,-61 47,-60 47,-59 48,-63 48,-62 48,-61 48,-60 48,-59 51,-89 52,-88 53,-85 53,-84 54,-83 54,-82 55,-82 55,-81 55,-80 55,-67 55,-66 56,-85 56,-80 56,-68 56,-67 56,-66 57,-86 57,-79 57,-78 57,-77 57,-69 57,-68 58,-81 58,-80 58,-79 58,-69 58,-68 59,-83 59,-82 59,-81 59,-80 59,-79 59,-78 59,-76 59,-70 59,-68 60,-84 60,-83 60,-82 60,-81 60,-78 60,-76 60,-75 60,-74 61,-84 61,-83 61,-82 61,-81 61,-80 61,-79 61,-78 61,-77 61,-76 61,-75 61,-74 61,-73 61,-72 62,-83 62,-82 62,-81 62,-80 62,-79 62,-77 62,-76 62,-75 62,-74 62,-73 62,-71 63,-86 63,-82 63,-78 63,-77 63,-75 63,-74 63,-73 63,-72 63,-71 64,-83 64,-82 64,-81 64,-80 64,-79 64,-76 64,-75 64,-74 64,-73 64,-71 65,-85 65,-84 65,-83 65,-81 65,-79 65,-77 65,-76 65,-75 65,-74 65,-73 65,-72 66,-82 66,-81 66,-79 66,-78 66,-77 66,-76 66,-75 66,-74 66,-72 67,-83 67,-82 67,-81 67,-79 67,-75 67,-74 67,-73 68,-83 68,-76 68,-73 69,-82 70,-80 70,-79 70,-76 70,-75 70,-72 71,-79',
  };

  var index = null;
  function cellIndex() {
    if (index) return index;
    index = {};
    Object.keys(CELLS).forEach(function (key) {
      CELLS[key].split(' ').forEach(function (cell) {
        (index[cell] = index[cell] || []).push(key);
      });
    });
    return index;
  }

  function wrap(lngCell) {
    var half = LNG_CELLS / 2;
    return ((((lngCell + half) % LNG_CELLS) + LNG_CELLS) % LNG_CELLS) - half;
  }

  function km(lat1, lng1, lat2, lng2) {
    var r = Math.PI / 180;
    var dLat = (lat2 - lat1) * r;
    var dLng = (lng2 - lng1) * r;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 12742 * Math.asin(Math.min(1, Math.sqrt(h)));
  }

  // The shortest distance from the point to any place in a cell: a lower
  // bound for every centroid in it.
  function cellKm(lat, lng, a, b) {
    var south = a * LAT_STEP;
    var west = b * LNG_STEP;
    var nearLat = Math.min(Math.max(lat, south), south + LAT_STEP);
    var dWest = (((lng - west) % 360) + 360) % 360;
    var nearLng = dWest <= LNG_STEP ? lng : dWest - LNG_STEP < 360 - dWest ? west + LNG_STEP : west;
    return km(lat, lng, nearLat, nearLng);
  }

  // The shards that can hold a centroid within MAX_KM, nearest first, each
  // with the lower bound of its distance.
  function candidates(lat, lng) {
    var cells = cellIndex();
    var a = Math.floor(lat / LAT_STEP);
    var b = Math.floor(lng / LNG_STEP);
    // A cell row is 111 km tall, more than MAX_KM, so one row each way is
    // enough. Cells narrow toward the pole, so the columns searched widen
    // until they span MAX_KM at the row's poleward edge.
    var edge = Math.min(89, Math.abs(lat) + LAT_STEP);
    var columns = Math.ceil(MAX_KM / (LNG_STEP * KM_PER_DEGREE * Math.cos((edge * Math.PI) / 180)));
    var bounds = {};
    for (var da = -1; da <= 1; da++) {
      for (var db = -columns; db <= columns; db++) {
        var lngCell = wrap(b + db);
        (cells[a + da + ',' + lngCell] || []).forEach(function (key) {
          var d = cellKm(lat, lng, a + da, lngCell);
          if (d <= MAX_KM && (bounds[key] === undefined || d < bounds[key])) bounds[key] = d;
        });
      }
    }
    return Object.keys(bounds)
      .map(function (key) {
        return { key: key, km: bounds[key] };
      })
      .sort(function (x, y) {
        return x.km - y.km;
      });
  }

  function fetchShard(config, key) {
    var url = config && config.postalShards && config.postalShards[key];
    if (!url) return Promise.reject(new Error('far: no postal shard ' + key));
    return fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('far: postal shard ' + response.status);
      return response.json();
    });
  }

  // Only real codes count; the 3-digit ZIP prefixes are fallbacks for typed
  // codes, not places. The shards the point's own cell holds (or else the
  // nearest one) load first, together; then any other shard whose lower
  // bound beats the best centroid so far. Usually one or two shards load.
  function nearestPostal(config, lat, lng) {
    if (!isFinite(lat) || !isFinite(lng)) return Promise.resolve(null);
    var list = candidates(lat, lng);
    if (!list.length) return Promise.resolve(null);
    var best = null;
    var loaded = {};

    function scan(shard) {
      var codes = (shard && shard.codes) || {};
      var country = shard && shard.country;
      if (country !== 'US' && country !== 'CA') return;
      Object.keys(codes).forEach(function (code) {
        var point = codes[code];
        var d = km(lat, lng, point[0], point[1]);
        if (!best || d < best.km) best = { postal: code, country: country, km: d };
      });
    }

    function round(keys) {
      keys.forEach(function (key) {
        loaded[key] = true;
      });
      return Promise.all(
        keys.map(function (key) {
          return fetchShard(config, key);
        })
      ).then(function (shards) {
        shards.forEach(scan);
        var limit = best ? best.km : MAX_KM;
        var next = list
          .filter(function (c) {
            return !loaded[c.key] && c.km < limit;
          })
          .map(function (c) {
            return c.key;
          });
        return next.length ? round(next) : null;
      });
    }

    var first = list
      .filter(function (c) {
        return c.km === 0;
      })
      .map(function (c) {
        return c.key;
      });
    return round(first.length ? first : [list[0].key]).then(function () {
      return best && best.km <= MAX_KM ? best : null;
    });
  }
  nearestPostal.candidates = candidates;
  nearestPostal.MAX_KM = MAX_KM;
  PwFar.nearestPostal = nearestPostal;

  // ---- The button ----

  function Locate(root) {
    this.root = root;
    this.form = root.querySelector('[data-far-form]');
    this.button = root.querySelector('[data-far-locate]');
    this.status = root.querySelector('[data-far-locate-status]');
    this.label = root.querySelector('[data-far-locate-label]');
    this.config = PwFar.config ? PwFar.config(root) : null;
    this.t = PwFar.ui ? PwFar.ui.i18n(root) : {};
    this.busy = false;
    this.submitting = false;
    if (!this.form || !this.button || !this.status) return;
    if (!('geolocation' in navigator) || !window.isSecureContext) return;

    var self = this;
    this.idleLabel = this.label ? this.label.textContent : '';
    this.button.hidden = false;
    this.button.addEventListener('click', function () {
      self.locate();
    });
    // A search the visitor starts by hand clears an old message here.
    this.form.addEventListener('submit', function () {
      if (!self.submitting) self.say('', false);
    });
  }

  Locate.prototype.say = function (text, isError) {
    this.status.textContent = text || '';
    this.status.hidden = !text;
    this.status.classList.toggle('far-error', !!(text && isError));
  };

  Locate.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.button.setAttribute('aria-busy', String(busy));
    this.button.disabled = busy;
    if (this.label) this.label.textContent = busy ? this.t.locating || this.idleLabel : this.idleLabel;
  };

  Locate.prototype.locate = function () {
    if (this.busy) return;
    var self = this;
    var t = this.t;
    this.setBusy(true);
    this.say(t.locating, false);
    navigator.geolocation.getCurrentPosition(
      function (position) {
        var c = position && position.coords;
        nearestPostal(self.config, c && c.latitude, c && c.longitude).then(
          function (found) {
            self.setBusy(false);
            if (!found) {
              self.say(t.locate_outside, true);
              return;
            }
            self.say('', false);
            self.use(found.postal);
          },
          function () {
            self.setBusy(false);
            self.say(t.load_error, true);
          }
        );
      },
      function (error) {
        self.setBusy(false);
        var code = error && error.code;
        self.say(code === 1 ? t.locate_denied : code === 3 ? t.locate_timeout : t.locate_unavailable, true);
      },
      { enableHighAccuracy: false, timeout: TIMEOUT_MS, maximumAge: 300000 }
    );
  };

  // Fill the field and submit the form the way a visitor would.
  Locate.prototype.use = function (postal) {
    this.form.elements.postal.value = postal;
    this.submitting = true;
    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
    } else {
      this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    this.submitting = false;
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-far-locator]').forEach(function (root) {
      if (root.farLocate) return;
      root.farLocate = new Locate(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
